<template>
    <span>
        <v-list-tile @click="mostrarCaixaDialogo">
            <v-list-tile-title>
                Desclassificar
            </v-list-tile-title>
        </v-list-tile>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="visibilidadeDialogo">
            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    <span><strong>{{itemOuLoteDescricao}}</strong> | Desclassificar Fornecedor</span>
                    <v-btn flat depressed @click="fecharCaixaDialogo">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0 az-form-content">
                    <div class="az-text mb-3">
                        <label>Fornecedor</label>
                        <p>{{razaoSocial}}</p>
                    </div>

                    <v-textarea v-model="motivoDesclassificacao"
                                :error-messages="errors.collect('Motivo da Desclassificação ' + itemOuLoteDescricao)"
                                v-validate="'required'"
                                label="Motivo da Desclassificação"
                                :name="'Motivo da Desclassificação ' + itemOuLoteDescricao"
                                placeholder="Digite aqui seu motivo"
                                rows="3"
                                maxlength="1000"
                                :counter="1000"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" flat outline @click="fecharCaixaDialogo">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoDesclassificar" color="primary" depressed @click="desclassificar">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'AcoesDesclassificar',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['itemOuLoteDescricao', 'razaoSocial'],
    data() {
        return {
            visibilidadeDialogo: false,
            motivoDesclassificacao: null,
            Modal
        }
    },
    methods: {
        async desclassificar() {
            await this.validarPreenchimento()
            this.$emit('desclassificar', this.motivoDesclassificacao)
            this.fecharCaixaDialogo()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Motivo da Desclassificação ' + this.itemOuLoteDescricao)
            if (!estaValidado) {
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        },
        mostrarCaixaDialogo() {
            setTimeout(() => {
                this.limparCampos()
                this.visibilidadeDialogo = true
            }, 500)
        },
        fecharCaixaDialogo() {
            this.limparCampos()
            this.visibilidadeDialogo = false
        },
        limparCampos() {
            this.motivoDesclassificacao = null
            this.$validator.reset()
        }
    },
    destroyed() {
        this.fecharCaixaDialogo()
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>